import { useState } from "react";

import { useTranslation } from "@impero-com/common/utils/i18n";
import { Button, Alert, FormBoxCompat, renderMarkdown } from "@impero-com/ui";
import { Checkbox } from "antd";

import { BulkImportStep } from "../stepsContainer";

import { ControlTemplateExporter } from "./TemplateExporter";
import * as theme from "./theme.css";

interface ExportStepProps {
    onStepChange: (step: BulkImportStep) => void;
}

export function ExportStep({ onStepChange }: ExportStepProps) {
    const { t } = useTranslation();
    const [includeExample, setIncludeExample] = useState(false);

    const handleNextStep = () => {
        onStepChange("upload");
    };

    return (
        <FormBoxCompat>
            <div className={theme.stepContainer}>
                <h2>{t("ControlsBulkImport_ExportStep_Title")}</h2>
                <Alert
                    showIcon={true}
                    type="info"
                    message={renderMarkdown(
                        t("ControlsBulkImport_ExportStep_Instructions")
                    )}
                    className={theme.infoAlertBox}
                />
                <div className={theme.checkboxContainer}>
                    <Checkbox
                        checked={includeExample}
                        onChange={(e) => setIncludeExample(e.target.checked)}
                    >
                        {t(
                            "ControlsBulkImport_ExportStep_IncludeExampleCheckboxTitle"
                        )}
                    </Checkbox>
                </div>
                <ControlTemplateExporter
                    onExport={() => onStepChange("upload")}
                    includeExampleRow={includeExample}
                />
                <div className={theme.buttonGroup}>
                    <Button variant="primary" onClick={handleNextStep}>
                        {t("ControlsBulkImport_ExportStep_ContinueButton")}
                    </Button>
                </div>
            </div>
        </FormBoxCompat>
    );
}
